// @ts-ignore
import { cn } from "@/lib/utils";

export function classNames(...classes: any) {
  return cn(classes);
}

export const truncate = (str: string, max: number, suffix: string) =>
  str.length < max
    ? str
    : `${str.substring(
        0,
        str.substring(0, max - suffix.length).lastIndexOf(" ")
      )}${suffix}`;
